import Action from '../../Action'
import './styles/createAgency.css'
import { useState ,useEffect} from 'react';
import LoadSimple from '../../LoadSimple';
import { useFetch } from '../../../hooks/useFetch';
import SelectorAdmin from '../../SelectorAdmin';
import SelectorIcons from '../../SelectorIcons';
import { capitalizeFirstLetter } from '../../../utils/utils';
import { lang } from '../../generales/traduction';
const ModalCreateException =({user,languaje,mode,devices,server,setRegisterIsValid,dataMantto,setData,loading,setLoading,setError,setEditActive,editActive,closCreateCisModal})=>{
    const obtenerFechaActualLocal = () => {
        const ahora = new Date();
        const anio = ahora.getFullYear();
        const mes = String(ahora.getMonth() + 1).padStart(2, '0'); // El mes se cuenta desde 0
        const dia = String(ahora.getDate()).padStart(2, '0');
        const horas = String(ahora.getHours()).padStart(2, '0');
        const minutos = String(ahora.getMinutes()).padStart(2, '0');
      
        return `${anio}-${mes}-${dia}T${horas}:${minutos}`;
      };
    const [loadingM,setLoadingM]=useState(false);
    const [IpValid,setIpValid]=useState(true)
    const [matchPassword,setMatchPassword]=useState(false)
    const [disabled,setDisabled]=useState(true)
    const [host,sethost]=useState([])
    const [ManttoData,setManttoData]=useState({name:(editActive)?dataMantto.name:"",img:(editActive)?dataMantto.img:"",color:(editActive)?dataMantto.color:"#ff0000",shortName:(editActive)?dataMantto.shortName:""})
    const [hostName,setHostName]=useState("")
    const [hostLocation,setHostLocation]=useState("")
    const [hostActivate,setHostActivate]=useState(0)
    const tec_list=useFetch('cassia/ci_elements/technologies','','','GET',server)
    const [msgError,setMsgError]=useState("")
    const [listSearchIP,setListSearchIP]=useState(false)


    const iconsSeverity=[
        {
            id:1,
            url:'cfe.png'
        },
        {
            id:2,
            url:'conagua.png'
        },
        {
            id:3,
            url:'manto.png'
        },
        {
            id:4,
            url:'implementacion.png'
        },
        {
            id:5,
            url:'agencyWarning.png'
        },
        {
            id:6,
            url:'storm.png'
        },
        {
            id:7,
            url:'damage.png'
        },
        {
            id:8,
            url:'crash.png'
        }
        ,
        {
            id:9,
            url:'rain.png'
        }
        ,
        {
            id:10,
            url:'hacker.png'
        }
        ,
        {
            id:11,
            url:'bug.png'
        },
        {
            id:12,
            url:'fire.png'
        },
        {
            id:13,
            url:'siren.png'
        }
        ,
        {
            id:14,
            url:'satelite.png'
        }
        ,
        {
            id:15,
            url:'ethernet.png'
        }
        ,
        {
            id:16,
            url:'wifi.png'
        }
    ]

    const handleChange=(e)=>{
        const {name,value}=e.target

        setManttoData((prevState)=>{
            return {
                ...prevState,
                [name]:value
            }
            
        })
    }

    useEffect(()=>{
     
          if( ManttoData.name==""   || ManttoData.shortName==="" || ManttoData.img==="" ){
              setDisabled(true)
          }else{
              setDisabled(false)
          }
    },[ManttoData])


    const Registrar=()=>{
     
      let method='POST'
      let url_add=''
      if(editActive){
          method='PUT'
          url_add=dataMantto.exception_agency_id
      }
      setLoading(true)
        const fetchDataPost = async () => {
          
       try {
           // console.log(localStorage.getItem('access_token'))
           const response = await fetch(server.url+'/api/v1/cassia/exception_agencies/'+url_add, {
             method: method,  
             headers: {
                 'Content-Type': 'application/json',
                 Authorization: `Bearer ${localStorage.getItem('access_token')}`,
               },
             body: JSON.stringify(ManttoData),
           });
           if (response.ok) {
             
             const data1 = await response.json();
             setLoading(false)
             // Manejo de la respuesta
             setData(data1)
             // console.log(data1);
             closCreateCisModal()
           setRegisterIsValid(true)
           
           const timer = setTimeout(() => {
             setRegisterIsValid(false)
             setEditActive(false)
             closCreateCisModal()
           }, 3000);
         
           } else {
             throw new Error('Error en la solicitud');
           }
       } catch (error) {
              setHostName("")
              setManttoData({name:"",shortName:"",img:"",color:"#ff0000"})
              
          setLoading(false)
            // Manejo de errores
            setError(error)
            closCreateCisModal()
            setRegisterIsValid(true)
            
            const timer = setTimeout(() => {
              setRegisterIsValid(false)
              setEditActive(false)
              closCreateCisModal()
            }, 3000);
            console.error(error);
          }
        };
    
        fetchDataPost();
        
  }
    useEffect(()=>{
        if(editActive){
            buscar_host(dataMantto.ip)
        }
    },[])
    const buscar_host=(ip)=>{
        setLoadingM(true)
        const fetchDataPost = async () => {
          
       try {
           const response = await fetch(server.url+'/api/v1/cassia/ci_elements/search_host/'+ip, {
               method: 'GET',  
               headers: {
                 'Content-Type': 'application/json',
                 'accept': 'application/json',
                 'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
               },
             });
           //   console.log(response)
           if (response.ok) {
               const data1 = await response.json();
               setLoadingM(false)
               if(data1.data.length==0){
                   sethost([])
               setHostName("")
               setHostLocation("")
               setHostActivate(0)
                   setMsgError("La IP no existe o no esta dada de alta")
                   setIpValid(false)
               }else{
                   setIpValid(true)

               }
               sethost(data1.data)
               setDisabled(true)
           } else {
               const data1 = await response.json();
               throw new Error('Error en la solicitud');
           }
       } catch (error) {
            console.error(error);
          }
        };

        fetchDataPost();
    }
    const changeOption=(option,index)=>{
        setManttoData((prevState)=>{
            return {
                ...prevState,
                ['tech_id']:option.value===""?0:(parseInt(option.value))
            }
            
        })
        // setManttoRelation(option.value)
    }
    const [fecha, setDate] = useState('2023-09-28')
    const validateIp= (ip) => {
        const ipRegex = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
        let result = ipRegex.test(ip);
        if(result){
            buscar_host(ip)
        }else{
            setHostLocation("")
            setMsgError("Direccion ip no valida")
            sethost([])
                setHostName("")
                setHostLocation("")
                setHostActivate(0)
        }
        return result;
    };
    const [resultList,setResultList]=useState([])
    const handleSearchHost=(e)=>{
      
      const term = e.target.value;
      const {name,value}=e.target
      if(name=="ip"){
          setManttoData((prevState)=>{
              return {
                  ...prevState,
                  ['ip']:value
              }
              
          })
      }
      // console.log(value)
      // setInputIP(value)
      setIpValid(validateIp(value))
      
      const filteredResults = devices.data.hosts.filter((item) => {
          
          return Object.entries(item).some(([key, value]) => {
            if (key === 'ip' || key=== 'Host') {
              return String(value).toLowerCase().includes(term.toLowerCase());
            }
            return false; // Si no es el atributo 'ip', retorna falso para continuar buscando en otros atributos
          });
        });
     
        setResultList(filteredResults)
    }

    //   console.log(resultList)
    const handleSelected=(element)=>{
        setIpValid(validateIp(element.ip))
        setManttoData((prevState)=>{
            return {
                ...prevState,
                ['ip']:element.ip
            }
            
        })
        setListSearchIP(false)
    }
    const closeListSearch=()=>{
        setListSearchIP(false)
    }
    const [iconsSelected,setIconSelected]=useState(0)

    const [colorHex, setColor] = useState('#ff0000');

    const handleColorChange = (event) => {
      // setColor(event.target.value);
      setManttoData((prevState)=>{
          return {
              ...prevState,
              ['color']:event.target.value
          }
          
      })
    };
    const handleIconChange=(id,url)=>{
      setIconSelected(id)
      setManttoData((prevState)=>{
          return {
              ...prevState,
              ['img']:url
          }
          
      })
    }

    const {name,shortName,img,color}=ManttoData;
    return(
        <div className="modal-GS-content">
            <div className='card-modal-gs modal-verificate'>
                <div className='head-card-modal-gs'>
                    <div className='title-head-card-modal-gs'>
                        {((editActive)?lang[languaje]['editar'].toUpperCase():lang[languaje]['crear'].toUpperCase())+' '+lang[languaje]['agenciaExcepciones'].toUpperCase()}
                    </div>
                </div>
                <div className='content-card-modal-gs' style={{overflowY: 'scroll',scrollbarWidth: 'thin'}}>
                
                                    <div className="form-GS-box"> 
                                    
                                    <div className="user-box-GS" >
                                    <input required name="name"  type="text" value={name}
                                    onChange={handleChange} />
                                        <label className='label-GS'>{capitalizeFirstLetter(lang[languaje]['nombre'])}</label>
                                        {
                                            // (name==="" || nombreIsValid)?'':<span className='form-msg-error'> Nombre no valido</span>
                                        }
                                        
                                    </div>
                                    
                                    <div className="user-box-GS " >
                                    <input required name="shortName"  maxLength={7} type="text" value={shortName}
                                    onChange={handleChange} />
                                        <label className='label-GS'>ShortName (max. 7 {lang[languaje]['caracteres']})</label>
                                        {
                                            // (name==="" || nombreIsValid)?'':<span className='form-msg-error'> Nombre no valido</span>
                                        }
                                        
                                    </div>
                                   
                                    <div className="user-box-GS" style={{height:'30%'}}>
                                        <div className='contListIconsAgencys'>
                                            {
                                                iconsSeverity.map((element,index)=>(
                                                    <div className='fieldIconsAgencys'>
                                                <div className={'compactIconAgency '+((img==element.url)?'iconAgencySelected':'')} onClick={()=>{handleIconChange(element.id,element.url)}}>
                                                <img src={'/iconos/'+element.url} alt={element.url} style={{ width: 35, height: 35}} />
                                                </div>
                                            </div>
                                                ))
                                            }
                                        </div>
                                        {/* {
                                           
                                            <SelectorIcons placeholder={'Seleccionar nivel...'} opGeneral={true} txtOpGen={'N/A'}  opt_de={0} origen={'Admin'} data={iconsSeverity}   titulo='Agency' selectFunction={changeOptionIcon} index={0}></SelectorIcons>

                                        } */}
                                        <label className='label-GS'>{capitalizeFirstLetter(lang[languaje]['icono'])}</label> 
                                       
                                    </div>
                                    <div className="user-box-GS" >
                                    <input type="color" id="color-picker" name="color-picker" style={{background:color}} value={color}
          onChange={handleColorChange}></input>
                                        <label className='label-GS'>Color ({lang[languaje]['selectColor']})</label>
                                        {
                                            // (name==="" || nombreIsValid)?'':<span className='form-msg-error'> Nombre no valido</span>
                                        }
                                        
                                    </div>
                                    
                                    
                                    
                                    <div className="user-box-GS" style={{height:'15%'}}>
                                        {
                                            (loading)?<LoadSimple></LoadSimple>
                                            :
                                            <>
                                            <Action disabled={false} origen='Cancelar' titulo={capitalizeFirstLetter(lang[languaje]['cancelar'])}  action={closCreateCisModal}/>
                                            <Action disabled={disabled} origen='Azul' titulo={capitalizeFirstLetter(lang[languaje]['guardar'])}  action={Registrar}/>
                                            </>
                                            // <Action disabled={disabled} origen='Login' titulo='Guardar'  action={Registrar}/>
                                        }
                                            
                                    {
                                        // (registerIsValid && data.message!=="User deleted successfully")?<span className='form-msg-ok'>Usuario registrado correctamente</span>:''
                                    }
                                        
                                    </div>
                                </div>
                </div>
                </div>
        </div>
    )
}

export default ModalCreateException